import * as React from "react";
import PauseIcon from "@material-ui/icons/PauseCircleFilled";
import { SvgIconProps, Tooltip } from "@material-ui/core";
import { BuildDelayErrorTooltip } from "../../helpers/installationTankHelpers";

type DelayIconProps = {
  date?: Date;
} & SvgIconProps;

function DelayIcon({ date, ...others }: DelayIconProps) {
  const [currentInterval, setCurrentInterval] = React.useState({
    start: date || new Date(),
    end: new Date(),
  });

  if (!date) {
    return null;
  }

  return (
    <Tooltip
      title={BuildDelayErrorTooltip(currentInterval)}
      onOpen={() => setCurrentInterval({ start: date, end: new Date() })}
    >
      <PauseIcon color="error" {...others} />
    </Tooltip>
  );
}

export default DelayIcon;
